import React, { useEffect, useState } from "react";
import { useContent } from "../lib/content";
import { api } from "../lib/api";

const IG_POST = "https://www.instagram.com/p/DUwUiy5E2fK/";

export default function Videos() {
  const kicker = useContent("page.videos.kicker", "/ 04 — VIDEOS");
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {});
  }, []);
  const title = useContent("page.videos.title", "LIVE FOOTAGE");
  const socialTitle = useContent("page.videos.social_title", "Social fragments");
  const socialIntro = useContent(
    "page.videos.social_intro",
    "Follow Inner Pulse on Instagram for live clips, studio work-in-progress and upcoming ritual announcements."
  );
  const ctaFollow = useContent("page.videos.cta_follow", "FOLLOW");
  return (
    <div data-testid="videos-page" className="px-6 md:px-12 py-20">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16" data-testid="videos-header">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-silver-400" />
            <span className="font-title text-[0.65rem] tracking-[0.4em] text-silver-400">
              {kicker}
            </span>
          </div>
          <h1 className="font-title text-silver-glow text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-[0.06em] whitespace-pre-line">
            {title}
          </h1>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20" data-testid="videos-youtube-grid">
          {videos.length === 0 && (
            <p className="font-body text-silver-500 text-sm md:col-span-2">No videos yet.</p>
          )}
          {videos.map((v, i) => {
            const isYT = !!v.youtube_id;
            return (
              <article key={v.id || i} className="flex flex-col gap-4" data-testid={`video-yt-${i}`}>
                <div className="aspect-video hairline bg-silver-900 overflow-hidden">
                  {isYT ? (
                    <iframe
                      width="100%"
                      height="100%"
                      src={`https://www.youtube.com/embed/${v.youtube_id}`}
                      title={v.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <video
                      src={v.direct_url}
                      poster={v.thumbnail_url || undefined}
                      controls
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-title text-[0.6rem] tracking-[0.3em] text-silver-600 mb-1">
                      / {isYT ? "YOUTUBE" : "VIDEO"} {String(i + 1).padStart(2, "0")}
                    </div>
                    <h3 className="font-title text-sm tracking-[0.1em] text-silver-200">{v.title}</h3>
                    {v.tag && (
                      <span className="inline-block mt-2 font-title text-[0.58rem] tracking-[0.3em] text-silver-100 hairline px-2 py-1 uppercase">
                        {v.tag}
                      </span>
                    )}
                  </div>
                  {isYT && (
                    <a
                      href={`https://youtu.be/${v.youtube_id}`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-ghost"
                      data-testid={`yt-external-${i}`}
                    >
                      OPEN →
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>

        <section data-testid="videos-instagram">
          <div className="hairline-t pt-10 mb-8">
            <div className="font-title text-[0.62rem] tracking-[0.3em] text-silver-600 mb-2">
              / INSTAGRAM
            </div>
            <h2 className="font-title text-2xl tracking-[0.1em] text-silver-100">
              {socialTitle}
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-start">
            <div className="aspect-square hairline bg-silver-900 overflow-hidden max-w-md w-full mx-auto md:mx-0">
              <iframe
                src={`${IG_POST}embed`}
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="no"
                allowtransparency="true"
                title="Instagram — Inner Pulse"
                style={{ background: "#000" }}
              />
            </div>
            <div className="flex flex-col gap-6">
              <p className="font-body text-silver-400 text-sm leading-relaxed">
                {socialIntro}
              </p>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noreferrer"
                className="btn-sharp self-start"
                data-testid="ig-follow-btn"
              >
                {ctaFollow}
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
